import Vue from 'vue';
import Router from 'vue-router';
const _import = require('./_import_' + process.env.NODE_ENV);
// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

/* sys */
Vue.use(Router);

export const constantRouterMap = [
  { path: '/login', component: _import('login'), hidden: true },
  { path: '/404', component: _import('error/404'), hidden: true },
  { path: '/401', component: _import('error/401'), hidden: true },
  {
    path: '/',
    component: _import('layout/Layout'),
    redirect: '/dashboard',
    name: '首页',
    hidden: true,
    children: [{ path: 'dashboard', component: _import('dashboard/index') }]
  }
]

export default new Router({
  // mode: 'history', // 后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});

export const asyncRouterMap = [
  {
    path: '/sys',
    component: _import('layout/Layout'),
    redirect: 'noredirect',
    name: '系统管理',
    meta: { function: [20, 400] },
    icon: 'zonghe',
    children: [
      {
        path: '/sys/config',
        component: _import('layout/L2Layout'),
        redirect: '/sys/config/account',
        name: '系统配置',
        icon: 'zonghe',
        meta: { function: [200000, 210000, 230000, 250000, 240000, 220000, 10000, 10010, 10020, 10030, 268000, 269100] },
        children: [
          { path: 'account', component: _import('sys/account/Account'), meta: { function: [200000] }, name: '账户管理' },
          { path: 'curraccount', component: _import('sys/account/CurrAccount'), meta: { function: [210000] }, name: '当前账户管理' },
          { path: 'user', component: _import('sys/user/User'), meta: { function: [220000] }, name: '用户管理' },
          { path: 'role', component: _import('sys/config/Role'), meta: { function: [230000] }, name: '角色管理' },
          { path: 'accountConfig', component: _import('sys/config/AccountConfig'), meta: { function: [240000] }, name: '系统配置' },
          { path: 'qmAppkey', component: _import('sys/qmAppkey/List'), meta: { function: [10000] }, name: '奇门配置' },
          { path: 'qmYcApp', component: _import('sys/qmYcApp/List'), meta: { function: [269100] }, name: '云仓配置' },
          { path: 'eventConfig', component: _import('sys/eventConfig/List'), meta: { function: [10010] }, name: '消息任务配置' },
          { path: 'eventTask', component: _import('sys/eventTask/List'), meta: { function: [10020] }, name: '消息任务' },
          { path: 'ediConfig', component: _import('sys/ediConfig/List'), meta: { function: [10030] }, name: 'EDI转换配置' },
          // { path: 'msg', component: _import('error/404'), name: '消息配置' },
          { path: 'pda', component: _import('sys/config/Pda'), meta: { function: [268000] }, name: '终端版本' }
        ]
      },
      {
        path: '/sys/operation',
        component: _import('layout/L2Layout'),
        redirect: '/sys/operation/menu',
        name: '运维配置',
        icon: 'zonghe',
        meta: { function: [265000] },
        children: [
          { path: 'menu', component: _import('sys/operation/Menu'), meta: { function: [265000] }, name: '菜单管理' }
        ]
      }
    ]
  },
  {
    path: '/data',
    component: _import('layout/Layout'),
    redirect: 'noredirect',
    name: '基础中心',
    meta: { function: [30, 40] },
    icon: 'zonghe',
    children: [
      {
        path: '/data/business',
        component: _import('layout/L2Layout'),
        redirect: '/data/business/customer',
        name: '商务管理',
        icon: 'zonghe',
        meta: { function: [300000, 330000, 391000, 392000] },
        children: [
          { path: 'customer', component: _import('data/customer/Customer'), meta: { function: [300000] }, name: '货主' },
          { path: 'carrier', component: _import('data/carrier/Carrier'), meta: { function: [330000] }, name: '承运商' },
          { path: 'printerConfiguration', component: _import('data/carrier/PrinterConfiguration'), meta: { function: [391000] }, name: '打印机配置' },
          { path: 'printerConfig', component: _import('data/carrier/PrinterConfig'), meta: { function: [392000] }, name: '弘人打印配置' },
        ]
      },
      {
        path: '/data/base',
        component: _import('layout/L2Layout'),
        redirect: '/data/base/item',
        name: '基础数据',
        icon: 'zonghe',
        meta: { function: [400500, 401000, 401500, 408000, 402000, 410500, 409900, 8008000, 320000, 405000, 409000, 471500, 408100, 471600, 471700] },
        children: [
          { path: 'item', component: _import('data/item/Item'), meta: { function: [400500] }, name: '商品管理' },
          { path: 'comboItem', component: _import('data/item/ComboItem'), meta: { function: [409900] }, name: '组合商品' },
          { path: 'warehouse', component: _import('data/warehouse/Warehouse'), meta: { function: [401000] }, name: '仓库管理' },
          { path: 'zone', component: _import('data/zone/Zone'), meta: { function: [401500] }, name: '库区管理' },
          { path: 'pickArea', component: _import('data/location/PickArea'), meta: { function: [8008000] }, name: '拣货区域' },
          { path: 'location', component: _import('data/location/Location'), meta: { function: [402000] }, name: '储位管理' },
          { path: 'locationVue', component: _import('data/location/LocationView'), meta: { function: [471700] }, name: '储位视图' },
          { path: 'transceiver', component: _import('data/customer/Transceiver'), meta: { function: [320000] }, name: '客户管理' },
          { path: 'box', component: _import('data/box/Box'), meta: { function: [408000] }, name: '容器管理' },
          { path: 'pm', component: _import('data/packagingMaterial/PackagingMaterial'), meta: { function: [405000] }, name: '包材管理' },
          { path: 'sowDesk', component: _import('data/sowDesk/SowDesk'), meta: { function: [409000] }, name: '播种墙' },
          { path: 'distributionArea', component: _import('data/distributionArea/DistributionArea'), meta: { function: [471500] }, name: '集货区管理' },
          { path: 'site', component: _import('data/site/Site'), meta: { function: [408100] }, name: '站点管理' },
          { path: 'archivesManagement', component: _import('data/archives/ArchivesManagement'), meta: { function: [471600] }, name: '档案管理' }
        ]
      },
      {
        path: '/data/config',
        component: _import('layout/L2Layout'),
        redirect: '/data/config/itemCategory',
        name: '基础配置',
        icon: 'zonghe',
        meta: { function: [410500, 407000, 420000, 800000, 418000, 419100, 424000] },
        children: [
          { path: 'itemCategory', component: _import('data/item/Category'), meta: { function: [410500] }, name: '商品品类' },
          { path: 'normalFlag', component: _import('data/normalFlag/NormalFlag'), meta: { function: [407000] }, name: '商品形态' },
          { path: 'abnormalCode', component: _import('data/abnormalCode/AbnormalCode'), meta: { function: [420000] }, name: '异常代码' },
          { path: 'bigCustomer', component: _import('data/bigCustomer/BigCustomer'), meta: { function: [418000] }, name: '承运商配置' },
          { path: 'bigPan', component: _import('data/bigPan/BigPan'), meta: { function: [800000] }, name: 'EMS大头笔' },
          { path: 'validRule', component: _import('data/validRule/ValidRule'), meta: { function: [419100] }, name: '有效期配置' },
          { path: 'safetyStock', component: _import('data/safetyStock/SafetyStock'), meta: { function: [424000] }, name: '安全库存设置' }
        ]
      },
      {
        path: '/data/rule',
        component: _import('layout/L2Layout'),
        redirect: '/data/rule/itemPackaging',
        name: '作业规则',
        icon: 'zonghe',
        meta: { function: [412000, 560000, 414500, 520000, 530000, 540000, 550000] },
        children: [
          { path: 'itemPackaging', component: _import('data/itemPackaging/ItemPackaging'), meta: { function: [412000] }, name: '包装规则' },
          { path: 'barcodeAnalyzeRule', component: _import('data/barcodeAnalyzeRule/BarcodeAnalyzeRule'), meta: { function: [560000] }, name: '条码解析规则' },
          { path: 'printTemplate', component: _import('data/printTemplate/PrintTemplate'), meta: { function: [414500] }, name: '打印模板' },
          { path: 'shelvesTactics', component: _import('data/shelvesTactics/ShelvesTactics'), meta: { function: [520000] }, name: '上架规则' },
          { path: 'tumoveRules', component: _import('data/tumoveRules/TumoveRules'), meta: { function: [530000] }, name: '周转规则' },
          { path: 'inventoryAllocation', component: _import('data/inventoryAllocation/InventoryAllocation'), meta: { function: [540000] }, name: '分配规则' },
          { path: 'pickListRules', component: _import('data/pickListRules/PickListRules'), meta: { function: [550000] }, name: '拣货规则' }
        ]
      },
      {
        path: '/data/import',
        component: _import('layout/L2Layout'),
        redirect: '/data/import',
        name: '数据导入',
        icon: 'zonghe',
        meta: { function: [431400, 431100, 431600, 431700, 431900, 433700, 431610, 432300, 433100, 433500, 433800, 433900] },
        children: [
          { path: 'itemUploadList', component: _import('data/import/ItemUploadList'), meta: { function: [431400] }, name: '商品导入' },
          { path: 'transceiverUploadList', component: _import('data/import/TransceiverUploadList'), meta: { function: [431100] }, name: '客户导入' },
          { path: 'zoneUploadList', component: _import('data/import/ZoneUploadList'), meta: { function: [431600] }, name: '储位导入' },
          { path: 'locationContainerUploadList', component: _import('data/import/LocationContainerUploadList'), meta: { function: [431700] }, name: '库存导入' },
          { path: 'turnoverboxUploadList', component: _import('data/import/TurnoverboxUploadList'), meta: { function: [431900] }, name: '容器导入' },
          { path: 'itemSingleUploadList', component: _import('data/import/ItemSingleUploadList'), meta: { function: [433700] }, name: '商品单字段导入' },
          { path: 'lineNoUploadList', component: _import('data/import/LineNoUploadList'), meta: { function: [431610] }, name: '储位动线导入' },
          { path: 'itemlocationUploadList', component: _import('data/import/ItemlocationUploadList'), meta: { function: [432300] }, name: '商品指定储位导入' },
          { path: 'itemPackagingCodeUploadList', component: _import('data/import/ItemPackagingCodeUploadList'), meta: { function: [433100] }, name: '包装规格导入' },
          { path: 'safetyStockUploadList', component: _import('data/import/SafetyStockUploadList'), meta: { function: [433500] }, name: '安全库存导入' },
          { path: 'inventoryDateList', component: _import('data/import/InventoryDateList'), meta: { function: [433800] }, name: '库存效期批量导入' },
          { path: 'expiredDateList', component: _import('data/import/ExpiredDateList'), meta: { function: [433900] }, name: '到期日期批量导入' }
        ]
      }

    ]
  },
  {
    path: '/orderCenter',
    component: _import('layout/Layout'),
    redirect: 'noredirect',
    name: '订单中心',
    meta: { function: [70] },
    icon: 'zonghe',
    children: [
      {
        path: '/orderCenter/manage',
        component: _import('layout/L2Layout'),
        redirect: '/orderCenter/manage/deliveryOutbound',
        name: '订单管理',
        icon: 'zonghe',
        meta: { function: [710000, 724000, 722000, 721000, 712000, 730001, 726000, 727000, 730000] },
        children: [
          { path: 'omsPickInbound', component: _import('orderCenter/inbound/OmsPickInbound'), meta: { function: [710000] }, name: '采购入库订单' },
          { path: 'returnInbound', component: _import('orderCenter/inbound/ReturnInbound'), meta: { function: [722000] }, name: '退货入库订单' },
          { path: 'deliveryOutboundB2C', component: _import('orderCenter/deliveryOutbound/DeliveryOutboundB2C'), meta: { function: [721000] }, name: 'B2C出库订单' },
          { path: 'deliveryOutbound', component: _import('orderCenter/deliveryOutbound/DeliveryOutbound'), meta: { function: [724000] }, name: 'B2B出库订单' },
          { path: 'returnOutbound', component: _import('orderCenter/deliveryOutbound/ReturnOutbound'), meta: { function: [712000] }, name: '退货出库订单' },
          { path: 'omsWarehouseTransfer', component: _import('orderCenter/deliveryOutbound/OmsWarehouseTransfer'), meta: { function: [730000] }, name: '调拨订单' },
          { path: 'dispatchOrder', component: _import('orderCenter/deliveryOutbound/DispatchOrder'), meta: { function: [730001] }, name: '调度订单' },
          { path: 'billOfLading', component: _import('orderCenter/inbound/BillOfLading'), meta: { function: [726000] }, name: '提货单' },
          { path: 'purchaseRequisitions', component: _import('orderCenter/inbound/purchaseRequisitions'), meta: { function: [727000] }, name: '采购申请单' }
        ]
      },
      {
        path: '/orderCenter/import',
        component: _import('layout/L2Layout'),
        redirect: '/orderCenter/import/itemHandle',
        name: '数据导入',
        icon: 'zonghe',
        meta: { function: [431500, 431200, 102000, 431800, 431300, 434000, 432700] },
        children: [
          { path: 'pickInBoundUploadList', component: _import('orderCenter/import/PickInBoundUploadList'), meta: { function: [431500] }, name: '采购入库订单导入' },
          { path: 'deliveryOutboundUploadList', component: _import('orderCenter/import/DeliveryOutboundUploadList'), meta: { function: [431200] }, name: '销售出库单导入' },
          { path: 'inventoryAdjustUploadList', component: _import('orderCenter/import/InventoryAdjustUploadList'), meta: { function: [102000] }, name: '损益单导入' },
          { path: 'returnOutboundUploadList', component: _import('orderCenter/import/ReturnOutboundUploadList'), meta: { function: [431800] }, name: '退货出库单导入' },
          { path: 'returnInboundUploadList', component: _import('orderCenter/import/ReturnInboundUploadList'), meta: { function: [431300] }, name: '退货入库单导入' },
          { path: 'transferOrderUploadList', component: _import('orderCenter/import/TransferOrderUploadList'), meta: { function: [434000] }, name: '调拨订单导入' },
          { path: 'batchInventoryLocationMoveUploadList', component: _import('orderCenter/import/BatchInventoryLocationMoveUploadList'), meta: { function: [432700] }, name: '移库单导入' },
          { path: 'deliveryOutboundTerminalUploadList', component: _import('orderCenter/import/DeliveryOutboundTerminalUploadList'), meta: { function: [434300] }, name: '团购单导入' }
        ]
      }
    ]
  },
  {
    path: '/business',
    component: _import('layout/Layout'),
    redirect: 'noredirect',
    name: '作业中心',
    meta: { function: [6] },
    icon: 'zonghe',
    children: [
      {
        path: '/business/receipt',
        component: _import('layout/L2Layout'),
        redirect: '/business/receipt/receiptTask',
        name: '收货管理',
        icon: 'zonghe',
        meta: { function: [810021, 890000, 830000, 821000, 728000] },
        children: [
          { path: 'receiptTask', component: _import('business/receipt/ReceiptTask'), meta: { function: [810021] }, name: '收货任务' },
          { path: 'boxReceipt', component: _import('business/receipt/BoxReceipt'), name: '箱收货', hidden: true },
          { path: 'shelvesTask', component: _import('business/shelves/ShelvesTask'), meta: { function: [890000] }, name: '上架任务' },
          { path: 'qcTask', component: _import('business/qcTask/QCTask'), meta: { function: [830000] }, name: '质检管理' },
          { path: 'ViewShelvesDetail', component: _import('business/shelves/ViewShelvesDetail'), meta: { function: [821000] }, name: '容器上架' },
          { path: 'orderDistribution', component: _import('business/receipt/orderDistribution'), meta: { function: [728000] }, name: '分货任务' }
        ]
      },
      {
        path: '/business/orders',
        component: _import('layout/L2Layout'),
        redirect: '/business/orders/ordersTask',
        name: '发货管理',
        icon: 'zonghe',
        meta: { function: [910000, 921000, 920000, 913000, 914000, 915200, 917000, 1032000, 915400, 950000, 914140] },
        children: [
          { path: 'ordersTask', component: _import('business/orders/OrdersTask'), meta: { function: [910000] }, name: '发货任务' },
          { path: 'ordersAnalyse', component: _import('business/orders/OrdersAnalyse'), meta: { function: [921000] }, name: '订单分析' },
          { path: 'ordersWave', component: _import('business/orders/OrdersWave'), meta: { function: [920000] }, name: '波次管理' },
          { path: 'pickListTask', component: _import('business/pickList/PickListTask'), meta: { function: [913000] }, name: '拣货任务' },
          { path: 'packingList', component: _import('business/packingList/PackingList'), meta: { function: [914000] }, name: '箱管理' },
          { path: 'deliverDocument', component: _import('business/deliverdocument/DeliverDocument'), meta: { function: [915200] }, name: '装箱管理' },
          { path: 'deliverHandoverOrder', component: _import('business/deliverHandoverOrder/DeliverHandoverOrder'), meta: { function: [917000] }, name: '交接单管理' },
          { path: 'replenishmentTaskDealDetail', component: _import('business/replenishmentTaskDeal/ReplenishmentTaskDealDetail'), meta: { function: [1032000] }, name: '补货任务' },
          { path: 'truckingOrder', component: _import('business/truckingOrder/TruckingOrder'), meta: { function: [915400] }, name: '派车管理' },
          { path: 'viewAllocateFailOrders', component: _import('business/orders/ViewAllocateFailOrders'), meta: { function: [950000] }, name: '订单缺货查询' },
          { path: 'distributionAreaReport', component: _import('business/distributionArea/DistributionAreaReport'), meta: { function: [914140] }, name: '集货区查询' }
        ]
      },
      {
        path: '/business/operator',
        component: _import('layout/L2Layout'),
        redirect: '/business/operator/site',
        name: '发货作业',
        icon: 'zonghe',
        meta: { function: [933000, 928000, 914010, 914110, 913100, 928001, 913200, 914120, 914150, 914130, 921200, 921200] },
        children: [
          { path: 'toPickRecover', component: _import('business/pickList/ToPickRecover'), meta: { function: [933000] }, name: '拣货回单' },
          { path: 'splitGoodsPage', component: _import('business/splitGoodsPage/SplitGoodsPage'), meta: { function: [928000] }, name: '播种分货' },
          { path: 'baseCheck', component: _import('business/ordersCheck/baseCheck'), meta: { function: [914010] }, name: '发货任务复核' },
          { path: 'offlineCheck', component: _import('business/ordersCheck/offlineCheck'), meta: { function: [914110] }, name: '拣货任务复核' },
          { path: 'singleCheck', component: _import('business/packingList/SingleCheck'), meta: { function: [913100] }, name: '单件复核' },
          { path: 'sortCheck', component: _import('business/packingList/SortCheck'), meta: { function: [928001] }, name: '分货复核' },
          { path: 'SameWarehousePacking', component: _import('business/packingList/SameWarehousePacking'), meta: { function: [913200] }, name: '同仓单件复核' },
          { path: 'offlineCheckNew', component: _import('business/ordersCheck/offlineCheckNew'), meta: { function: [914120] }, name: '线下复核新' },
          { path: 'site', component: _import('business/deliverdocument/SiteSign'), meta: { function: [914150] }, name: '站点签收' },
          { path: 'joinBoxPrint', component: _import('business/deliverdocument/JoinBoxPrint'), meta: { function: [914130] }, name: '线下合箱热敏' },
          { path: 'crrierHandover', component: _import('business/deliverdocument/CarrierHandover'), meta: { function: [921200] }, name: '热敏交接' },
          { path: 'pcHandover', component: _import('business/deliverdocument/PCHandover'), meta: { function: [921200] }, name: '派车交接' }

        ]
      },
      {
        path: '/business/inventory',
        component: _import('layout/L2Layout'),
        redirect: 'business/inventory/inventoryTask',
        name: '库存管理',
        icon: 'zonghe',
        meta: { function: [1012000, 1011000, 1013000, 1014000, 1020000, 1050000] },
        children: [
          { path: 'inventoryLocationMove', component: _import('business/inventoryTask/InventoryLocationMove'), meta: { function: [1012000] }, name: '库存移库' },
          { path: 'InventoryAdjust', component: _import('business/inventory/InventoryAdjust'), meta: { function: [1011000] }, name: '库存损益' },
          { path: 'InventoryFrozen', component: _import('business/inventory/InventoryFrozen'), meta: { function: [1013000] }, name: '库存冻结' },
          { path: 'InventoryUnfrozen', component: _import('business/inventory/InventoryUnfrozen'), meta: { function: [1014000] }, name: '库存解冻' },
          { path: 'stockTaking', component: _import('business/stockTaking/StockTaking'), meta: { function: [1020000] }, name: '盘点管理' },
          { path: 'itemProcess', component: _import('business/inventory/ItemProcess'), meta: { function: [1050000] }, name: '库内加工' }
        ]
      }
      // {
      //   path: '/business/stock',
      //   component: _import('layout/L2Layout'),
      //   redirect: '/business/stock/stockTaking',
      //   name: '盘点管理',
      //   icon: 'zonghe',
      //   meta: { function: [1020000] },
      //   children: [

      //     { path: 'StockTask', component: _import('business/stockTaking/StocktakingTask'), meta: { function: [1021000] }, name: '盘点任务' }
      //   ]
      // }
    ]
  },
  {
    path: '/query',
    component: _import('layout/Layout'),
    redirect: 'noredirect',
    name: '报表中心',
    meta: { function: [1800000] },
    icon: 'zonghe',
    children: [
      {
        path: '/query/record',
        component: _import('layout/L2Layout'),
        redirect: '/query/record',
        name: '库存记录查询',
        icon: 'zonghe',
        meta: { function: [1802700, 1802600, 1803700, 1808510, 1803500, 1808000, 1808600, 1808520, 1803400, 1808610] },
        children: [
          { path: 'inventoryTotal', component: _import('query/record/InventoryTotal'), meta: { function: [1802700] }, name: '总库存' },
          { path: 'locationContainer', component: _import('query/record/LocationContainer'), meta: { function: [1802600] }, name: '库存明细' },
          { path: 'inventoryMonitoring', component: _import('query/record/InventoryMonitoring'), meta: { function: [1803700] }, name: '库存监控' },
          { path: 'inventoryRecordHistory', component: _import('query/record/InventoryRecordHistory'), meta: { function: [1808510] }, name: '库存交易记录' },
          { path: 'DailyInventory', component: _import('query/record/DailyInventoryExport'), meta: { function: [1803400] }, name: '每日库存' },
          { path: 'snInventory', component: _import('query/record/SnInventory'), meta: { function: [1803500] }, name: 'SN库存' },
          { path: 'inventoryWarningRecord', component: _import('query/record/InventoryWarningRecord'), meta: { function: [1808000] }, name: '保质期预警' },
          { path: 'viewSafetyInventory', component: _import('query/record/ViewSafetyInventory'), meta: { function: [1808600] }, name: '安全库存预警报表' },
          { path: 'ordersRankingList', component: _import('query/record/OrdersRankingList'), meta: { function: [1808520] }, name: '出库排名周转报表' },
          { path: 'dailyLc', component: _import('query/record/DailyLc'), meta: { function: [1808610] }, name: '每日库存明细' }
        ]
      },
      {
        path: '/query/operation',
        component: _import('layout/L2Layout'),
        redirect: '/query/operation',
        name: '库存作业查询',
        icon: 'zonghe',
        meta: { function: [1815000, 1806500, 1805000, 1835000, 1808502, 1808501, 1803000, 1804000, 1807000, 1825000, 1807500, 1812555, 1829800, 1830100] },
        children: [
          { path: 'showOrderDetail', component: _import('query/operation/ShowOrderDetail'), meta: { function: [1815000] }, name: '发货任务明细' },
          { path: 'showReceiptDetail', component: _import('query/operation/ShowReceiptDetail'), meta: { function: [1806500] }, name: '收货任务明细' },
          { path: 'showPickListDetail', component: _import('query/operation/ShowPickListDetail'), meta: { function: [1805000] }, name: '拣货单明细' },
          { path: 'performanceReport', component: _import('query/operation/PerformanceReport'), meta: { function: [1835000] }, name: '绩效统计报表' },
          { path: 'packingListDetail', component: _import('query/operation/PackingListDetail'), meta: { function: [1808502] }, name: '装箱单明细' },
          { path: 'inventoryAdjustDetailRecord', component: _import('query/operation/InventoryAdjustDetailRecord'), meta: { function: [1808501] }, name: '损益单明细' },
          { path: 'snInLocationRecord', component: _import('query/operation/SnInLocationRecord'), meta: { function: [1803000] }, name: 'SN入库记录' },
          { path: 'snOutLocationRecord', component: _import('query/operation/SnOutLocationRecord'), meta: { function: [1804000] }, name: 'SN出库记录' },
          { path: 'shelvesRecord', component: _import('query/operation/ShelvesRecord'), meta: { function: [1807000] }, name: '上架记录' },
          { path: 'itemProcessDetail', component: _import('query/operation/ItemProcessDetail'), meta: { function: [1825000] }, name: '加工单明细' },
          { path: 'locationViewReport', component: _import('query/operation/LocationViewReport'), meta: { function: [1807500] }, name: '指定储位' },
          { path: 'inventoryAndSale', component: _import('query/operation/InventoryAndSale'), meta: { function: [1812555] }, name: '进销存报表' },
          { path: 'performanceDetailReport', component: _import('query/operation/PerformanceDetailReport'), meta: { function: [1829800] }, name: '绩效明细报表' },
          { path: 'locationUseCountReport', component: _import('query/operation/LocationUseCountReport'), meta: { function: [1830100] }, name: '储位占用率报表' },
          { path: 'itemGroupReport', component: _import('query/operation/ItemGroupReport'), meta: { function: [1830200] }, name: '商品品类报表' },
          { path: 'stockOutDetail', component: _import('query/operation/StockOutDetail'), meta: { function: [1831000] }, name: '缺货明细订单报表' },
          { path: 'stockOutCollect', component: _import('query/operation/StockOutCollect'), meta: { function: [1831050] }, name: '缺货汇总报表' }
        ]
      },
      {
        path: '/query/qtyCenter',
        component: _import('layout/L2Layout'),
        redirect: '/query/qtyCenter',
        name: '看板中心',
        icon: 'zonghe',
        meta: {},
        children: [
          { path: 'dailyQty', component: _import('query/dailyReport/DailyQtyReport'), name: '当日出库单量' },
          { path: 'dailyReceiveQty', component: _import('query/dailyReport/DailyReceiveQtyReport'), name: '当日入库数量' },
          { path: 'dailyStd', component: _import('query/dailyReport/DailyStdReport'), name: '每日出入库单量' }
        ]
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
];



// WEBPACK FOOTER //
// ./src/router/index.js